import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export interface WeightedMatch {
  therapist: {
    id: string;
    displayName: string;
    email: string;
    specializations: string[];
    languages: string[];
    hourlyRateNgn: number;
    ratingAvg: number;
    ratingCount: number;
    bio: string;
    gender: string;
    faithAffiliation: string | null;
  };
  score: number;
  reasons: string[];
}

export function useMatchingRecommendations(enabled = true) {
  return useQuery({
    queryKey: ['matching-recommendations'],
    queryFn: () =>
      api.get<{ data: WeightedMatch[]; count: number; mode: string }>(
        '/matching/recommendations?limit=5'
      ),
    enabled,
    staleTime: 0,
    retry: 1,
  });
}

export function usePostAssessmentMatches(enabled: boolean) {
  return useQuery({
    queryKey: ['post-assessment-matches'],
    queryFn: () =>
      api.post<{ data: WeightedMatch[]; count: number; mode: string }>('/matching/match', {
        mode: 'weighted',
        limit: 5,
      }),
    enabled,
    staleTime: 0,
    retry: 1,
  });
}
